import { TrackingEventService } from "../api/TrackingEventService";
import { TimeTrackingEvent } from "../types/event";

export type TotalTimeResponse = {
  totalTime: number;
  firstEvent: TimeTrackingEvent | null;
  lastEvent: TimeTrackingEvent | null;
  isRunning: boolean;
  isPaused: boolean;
};

export const calculateTotalTime = async (
  appointmentId: string,
  employeeId?: string
): Promise<TotalTimeResponse> => {
  try {
    if (employeeId) {
      const { data } =
        await TrackingEventService.GetTotalTimeByAppointmentPerEmployeeId(
          appointmentId,
          employeeId
        );

      return {
        totalTime: data.totalSecondsIncludingOpen,
        firstEvent: data.firstEvent,
        lastEvent: data.lastEvent,
        isRunning: data.isRunning,
        isPaused: data.isPaused,
      };
    }

    const { data } =
      await TrackingEventService.GetTotalTimeByAppointment(appointmentId);

    return {
      totalTime: data.totalSecondsIncludingOpen,
      firstEvent: data.firstEvent,
      lastEvent: data.lastEvent,
      isRunning: data.isRunning,
      isPaused: data.isPaused,
    };
  } catch (error) {
    console.error(error);

    return {
      totalTime: 0,
      firstEvent: null,
      lastEvent: null,
      isRunning: false,
      isPaused: false,
    };
  }
};
